import PlacePartialsCircle from "./PlacePartialsCircle";

export default PlacePartialsCircle;
